export default __webpack_public_path__ + "static/media/mainlogo.3574aa43.png";